var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconUsers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.00016 10.75C2.94771 10.75 2.0835 11.6142 2.0835 12.6667C2.0835 13.0809 1.74771 13.4167 1.3335 13.4167C0.919283 13.4167 0.583496 13.0809 0.583496 12.6667C0.583496 10.7858 2.11928 9.25 4.00016 9.25H6.66683C8.54771 9.25 10.0835 10.7858 10.0835 12.6667C10.0835 13.0809 9.74771 13.4167 9.3335 13.4167C8.91928 13.4167 8.5835 13.0809 8.5835 12.6667C8.5835 11.6142 7.71928 10.75 6.66683 10.75H4.00016Z",
    className: "icon-fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.47941 4.54031C5.79551 3.91506 4.75082 3.93474 4.21622 4.51046C3.64287 5.12791 3.6565 6.08188 4.28288 6.75645C4.8198 7.33467 5.80553 7.35242 6.48962 6.71719C7.08904 6.16059 7.12109 5.19202 6.47941 4.54031ZM7.50653 3.44703C6.32303 2.35171 4.31183 2.20308 3.11703 3.48978C1.95704 4.739 2.07675 6.58503 3.18369 7.77713C4.38011 9.06558 6.32772 8.91449 7.51029 7.81638C8.77315 6.64373 8.74524 4.68889 7.5342 3.47371C7.52968 3.46914 7.5251 3.46461 7.52045 3.46013C7.51585 3.45569 7.51121 3.45133 7.50653 3.44703Z",
    className: "icon-fill"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.91699 10.3335C9.91699 9.91928 10.2528 9.5835 10.667 9.5835H12.667C14.2145 9.5835 15.417 10.7859 15.417 12.3335C15.417 12.7477 15.0812 13.0835 14.667 13.0835C14.2528 13.0835 13.917 12.7477 13.917 12.3335C13.917 11.6144 13.3861 11.0835 12.667 11.0835H10.667C10.2528 11.0835 9.91699 10.7477 9.91699 10.3335Z",
    className: "icon-fill"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3502 6.01137C11.9525 5.66756 11.3527 5.70809 11.0637 5.99718C11.0544 6.00648 11.0448 6.01553 11.035 6.02432C10.7493 6.28146 10.6972 6.86112 11.0908 7.29846C11.3479 7.58417 11.9276 7.63632 12.3649 7.24271C12.6803 6.95887 12.7254 6.40101 12.3502 6.01137ZM13.3628 4.90434C12.4313 4.07129 10.9242 4.0314 10.0171 4.92257C8.98571 5.86668 9.1732 7.41008 9.97585 8.30191C10.9187 9.34954 12.4724 9.16405 13.3684 8.35766C14.3806 7.44665 14.3403 5.88545 13.4022 4.94173C13.3959 4.93532 13.3894 4.92899 13.3829 4.92276C13.3762 4.91648 13.3695 4.91034 13.3628 4.90434Z",
    className: "icon-fill"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUsers);
export default __webpack_public_path__ + "static/media/icon-users.2290a509d84b555c903814a7d8cf508c.svg";
export { ForwardRef as ReactComponent };